/*
  Perro Loco — Carrito lateral

  Dos cosas:
  1. El cierre desde "Seguir comprando" (Épica 2, historia 2.4).
  2. El rescate del agregado parcial (ver abajo).

  El resto del comportamiento del panel —role="dialog", foco atrapado, cierre
  con Esc y devolución del foco— ya lo resuelve cart-drawer.js del tema y no se
  toca.
*/

/* ------------------------------------------------------------------ *
 * "Seguir comprando"
 *
 * Va delegado en el documento porque cart-drawer.renderContents() reemplaza el
 * HTML del pie en cada actualización: un listener puesto sobre el botón se
 * perdería en el primer agregado.
 * ------------------------------------------------------------------ */

document.addEventListener('click', (evento) => {
  const disparador = evento.target.closest('[data-pl-cerrar-carro]');
  if (!disparador) return;

  const panel = disparador.closest('cart-drawer');
  if (!panel) return;

  evento.preventDefault();
  panel.close();
});

/* ------------------------------------------------------------------ *
 * Agregado parcial: cuando se pide más de lo que hay
 *
 * Si el cliente pide 5 y quedan 2, Shopify responde 422 con "Debido a la
 * disponibilidad, solo se añadieron 2 artículos" — pero LOS DOS SÍ ENTRARON
 * al carrito. El tema trata ese 422 como un fallo cualquiera: muestra el
 * mensaje y no abre el panel.
 *
 * El resultado es lo peor de los dos mundos: parece que no se compró nada, y
 * el carrito quedó con producto. Hay que recargar para descubrirlo.
 *
 * No se puede distinguir el agregado parcial del fallo total mirando el texto
 * del error, porque viene traducido por Shopify. Se distingue contando: si
 * después del error hay más artículos que antes, algo entró.
 * ------------------------------------------------------------------ */

window.plCarro = (() => {
  let conteo = null;

  const leerConteo = () =>
    fetch(`${window.routes.cart_url}.js`)
      .then((r) => r.json())
      .then((c) => c.item_count)
      .catch(() => null);

  const panel = () => document.querySelector('cart-drawer');

  // Vuelve a pedirle al servidor el HTML del panel y del globo del ícono, y se
  // los entrega a renderContents() con la forma que espera.
  const refrescarYAbrir = async () => {
    const p = panel();
    if (!p) return;

    const ids = p.getSectionsToRender().map((s) => s.id);
    const url = `${window.location.pathname}?sections=${ids.join(',')}`;

    try {
      const secciones = await (await fetch(url)).json();
      p.classList.remove('is-empty');
      p.renderContents({ sections: secciones });
    } catch (e) {
      // Si ni siquiera esto responde, recargar es preferible a dejar al
      // cliente creyendo que no compró nada.
      window.location.reload();
    }
  };

  const avisar = (mensaje) => {
    const p = panel();
    if (!p || !mensaje) return;
    const dentro = p.querySelector('.drawer__inner');
    if (!dentro) return;

    p.querySelector('.pl-carro__aviso')?.remove();
    const aviso = document.createElement('div');
    aviso.className = 'pl-carro__aviso';
    aviso.setAttribute('role', 'status');
    aviso.textContent = mensaje;
    dentro.prepend(aviso);
  };

  // Devuelve true si, pese al error, entró algo al carrito.
  const rescatarAgregadoParcial = async (mensaje) => {
    const antes = conteo;
    const ahora = await leerConteo();
    conteo = ahora;

    if (antes === null || ahora === null || ahora <= antes) return false;

    await refrescarYAbrir();
    avisar(mensaje);
    return true;
  };

  const recordarConteo = () => leerConteo().then((n) => (conteo = n));

  recordarConteo();
  document.addEventListener('DOMContentLoaded', recordarConteo);

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, recordarConteo);
    // La ficha de producto usa el <product-form> del tema, que publica esto.
    subscribe(PUB_SUB_EVENTS.cartError, (datos) => {
      rescatarAgregadoParcial(datos?.errors || datos?.message);
    });
  }

  return { rescatarAgregadoParcial, recordarConteo };
})();
